import { PartnerProgramActiveState } from '@layout/partner-program-active/store/states/partner-program-active.state';

export const partnerProgramActiveState = [PartnerProgramActiveState];
